import { PaperCategoryInsert, PaperCategoryDelete, PaperCategoryUpdate, PaperCategoryGetById, PaperCategoryGetList, PaperCategoryGetPageList } from "@/api/papercategory/index.js";

const state = {

}

const getters = {

}

const mutations = {

}

const actions = {
    // 新增
    PaperCategoryInsert(context, payload) {
        return new Promise((resolve, reject) => {
            
            
            PaperCategoryInsert({ ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 更新
    PaperCategoryUpdate(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            PaperCategoryUpdate(id, { ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取
    PaperCategoryGetById(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            PaperCategoryGetById(id).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取列表
    PaperCategoryGetList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            PaperCategoryGetList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取分页列表
    PaperCategoryGetPageList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            PaperCategoryGetPageList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}